// extracted by mini-css-extract-plugin
export default {"rootClassName":"filtros-listagem-contrato-assessor"};